import React from "react";
import mainLogo from "../assets/img/logo.png";
import track from "./Track";
import { Modal } from "./Modal";

export const Header = ({ show, setShow }) => {
  // const [show, setShow] = React.useState(false);
  return (
    <>
      <Modal show={show} setShow={setShow} />
      <header className="page flex start">
        <div className="main-logo-container flex" style={{ marginTop: "64px" }}>
          <img
            src={mainLogo}
            width="100%"
            alt=""
            className="main-logo shadowed"
            style={{ borderRadius: "5px" }}
          />
        </div>

        <h1
          className="font1 bold catch"
          style={{ color: "white", margin: "8px" }}
        >
          Seek Vengeance through Steel and Secrecy
        </h1>

        {/* <h1
          className="font1 bold catch"
          style={{ color: "white", fontSize: "1.5em" }}
        >
          Coming <span>2.16.21 (US) </span>
          <span>2.19.21 (EU) </span>
          <span>2.27.21 (ANZ)</span>
        </h1> */}
        <div className="flex" style={{ width: "80%" }}>
          {/* <a href="https://store.nisamerica.com/preorders/fallen-legion-revenants" target="_blank" onClick={e=>track('preorder')}> */}
          <button
            style={{ margin: 8 }}
            onClick={() => {
              track("preorder");
              setShow(true);
            }}
          >
            BUY NOW
          </button>

          {/* </a> */}
          {/* <button style={{backgroundColor:'#5375b3'}}>TRAILER</button> */}
          <button
            style={{ margin: 8, backgroundColor: "#5375b3" }}
            onClick={() => {
              document
                .getElementById("dlc")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            Check out the DLC
          </button>
          <div className="line"></div>
          {/* <div
            className="nav-btn"
            onClick={() => {
              document
                .getElementById("dlc")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            DLC
          </div> */}
        </div>
      </header>
    </>
  );
};
